import { http } from './http'
import { auth } from './auth'
import { RenderedVersionSchema, VersionSchema } from '../schemas'
import { parseWithZod } from '../utils/parse-with-zod'
import { CreateVersionPayload } from '../types'
import z from 'zod'

const PushToDmsPayloadSchema = z.object({
  folder_id: z.string(),
  workspace_id: z.number().optional(),
  format: z.string(),
  filename: z.string(),
})

type PushToDmsPayload = z.infer<typeof PushToDmsPayloadSchema>

export const RenderedVersionResponseSchema = z.object({
  rendered_version: RenderedVersionSchema,
})

const VersionResponseSchema = z.object({
  version: VersionSchema,
})

export const versions = {
  create: async (payload: CreateVersionPayload, dealId: number) => {
    const regionHost = auth.getUserRegionHost()
    const result = await http.post(`${regionHost}/api/versions`, { version: payload }, dealId)
    return parseWithZod(VersionResponseSchema, result).version
  },

  update: async (versionId: number, payload: { is_final?: boolean }, dealId: number) => {
    const regionHost = auth.getUserRegionHost()
    const result = await http.put(
      `${regionHost}/api/versions/${versionId}`,
      { version: payload },
      dealId,
    )
    return parseWithZod(VersionResponseSchema, result).version
  },

  render: async (versionId: number, dealId: number) => {
    const regionHost = auth.getUserRegionHost()
    const result = await http.post(
      `${regionHost}/api/versions/${versionId}/render`,
      undefined,
      dealId,
    )
    const parsedResult = parseWithZod(RenderedVersionResponseSchema, result)
    return parsedResult.rendered_version
  },

  pushToDms: async (versionId: number, payload: PushToDmsPayload, dealId: number) => {
    const regionHost = auth.getUserRegionHost()
    const result = await http.post(
      `${regionHost}/api/versions/${versionId}/push_to_dms`,
      payload,
      dealId,
    )
    return parseWithZod(VersionResponseSchema, result).version
  },

  pushNewDmsVersion: async (versionId: number, payload: { format: string }, dealId: number) => {
    const regionHost = auth.getUserRegionHost()
    const result = await http.post(
      `${regionHost}/api/versions/${versionId}/push_new_dms_version`,
      payload,
      dealId,
    )
    return parseWithZod(VersionResponseSchema, result).version
  },
}
